import cc from "classcat"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import LogoProtected from "images/logo-protected-by-somebuddy.svg"

const Tag = ({ children, className = "" }) => {
  return (
    <div
      className={cc([
        " m-0 my-4 inline-block rounded-full px-6 py-1 font-bold",
        className,
        {
          "bg-teal-100": !className.includes("bg-"),
        },
      ])}
    >
      {children}
    </div>
  )
}

const FeatureCard = ({ feature, wideLeft }) => {
  return (
    <div className="flex h-full flex-col items-start">
      <div className={cc(["mx-auto", wideLeft ? "lg:px-11 xl:px-16" : ""])}>
        <GatsbyImage className="" image={getImage(feature.image)} fadeIn />
      </div>
      <div>
        <h3 className="m-0 mt-6 text-left font-display text-xl tracking-normal text-zinc-800">
          {feature.name}
        </h3>
        <p
          className={cc([
            "m-0 mt-3 text-left font-display text-sm font-bold text-zinc-800 underline",
          ])}
        >
          {feature.subheader}
        </p>
        {feature.description && (
          <p className="m-0 mt-5 text-left text-sm text-zinc-800">
            {feature.description}
          </p>
        )}
      </div>
    </div>
  )
}

export default function Service({ features = [], title = "" }) {
  return (
    <div className="relative bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="sm:max-w-xl">
          <h2 className="m-0 whitespace-pre-line text-left text-3xl font-extrabold tracking-tight text-neutral-800 sm:text-4xl lg:text-5xl">
            {title}
          </h2>
        </div>
        <div className="mt-12">
          <div className="gap-20 space-y-6 lg:grid lg:grid-cols-4 lg:space-y-0">
            {features.map((feature) => (
              <FeatureCard feature={feature} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
